import { RoiValues, RoiResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

// ROI = (finalValue - initialInvestment) / initialInvestment * 100
export function calculateRoi(values: RoiValues, t?: ToolsTranslations['roi']): RoiResult {
  const { investedCapital, finalValue } = values;
  if (investedCapital <= 0) return { percent: null, isValid: false, message: t?.invalid.investedCapital };
  if (finalValue < 0) return { percent: null, isValid: false, message: t?.invalid.finalValue };
  const roi = ((finalValue - investedCapital) / investedCapital) * 100;
  const percent = Math.round(roi * 100) / 100; // two decimals
  if (!isFinite(percent)) return { percent: null, isValid: false, message: t?.invalid.generic };
  return { percent, isValid: true };
}


